export default __webpack_public_path__ + "static/media/campaign-2-ar.3ca00bc5.svg";